import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { useLanguage } from '../contexts/LanguageContext';

export const Datenschutz = () => {
  const { t } = useLanguage();
  const L = (key) => t(`legal.datenschutz.${key}`);
  return (
    <div className="min-h-screen flex flex-col bg-ngbc-beige">
      <Header />
      <main className="flex-grow max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-12 mt-20">
        <h1 className="text-4xl font-bold text-ngbc-dark mb-8">{L('title')}</h1>
        
        <div className="bg-ngbc-beige rounded-lg shadow-md p-8 space-y-6">
          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">{L('s1Title')}</h2>
            <h3 className="text-xl font-semibold text-ngbc-dark mb-3">{L('s1Sub')}</h3>
            <p className="text-ngbc-dark-text">
              {L('s1P1')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">{L('s2Title')}</h2>
            <h3 className="text-xl font-semibold text-ngbc-dark mb-3">{L('s2Who')}</h3>
            <p className="text-ngbc-dark-text">
              {L('s2WhoP')}
            </p>

            <h3 className="text-xl font-semibold text-ngbc-dark mb-3 mt-6">Wie erfassen wir Ihre Daten?</h3>
            <p className="text-ngbc-dark-text">
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich 
              z. B. um Daten handeln, die Sie in ein Kontaktformular oder bei der Anmeldung zur Veranstaltung 
              eingeben.
            </p>
            <p className="text-ngbc-dark-text mt-4">
              Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere 
              IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem 
              oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese 
              Website betreten.
            </p>

            <h3 className="text-xl font-semibold text-ngbc-dark mb-3 mt-6">Wofür nutzen wir Ihre Daten?</h3>
            <p className="text-ngbc-dark-text">
              Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. 
              Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden, sofern Sie hierzu Ihre 
              Einwilligung erteilt haben.
            </p>

            <h3 className="text-xl font-semibold text-ngbc-dark mb-3 mt-6">Welche Rechte haben Sie bezüglich Ihrer Daten?</h3>
            <p className="text-ngbc-dark-text">
              Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer 
              gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung 
              oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt 
              haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das 
              Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten 
              zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
            </p>
            <p className="text-ngbc-dark-text mt-4">
              Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">3. Hosting</h2>
            <p className="text-ngbc-dark-text">
              Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
            </p>
            <p className="text-ngbc-dark-text mt-4">
              <strong>[Hosting-Anbieter]</strong><br />
              [Adresse des Hosting-Anbieters]
            </p>
            <p className="text-ngbc-dark-text mt-4">
              Wenn Sie unsere Website besuchen, werden Ihre Daten auf den Servern des Hosting-Anbieters 
              verarbeitet. Hierbei können auch personenbezogene Daten erfasst werden. Die Verarbeitung erfolgt 
              auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer sicheren und 
              effizienten Bereitstellung unserer Website).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">4. Allgemeine Hinweise und Pflichtinformationen</h2>
            <h3 className="text-xl font-semibold text-ngbc-dark mb-3">Datenschutz</h3>
            <p className="text-ngbc-dark-text">
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln 
              Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften 
              sowie dieser Datenschutzerklärung.
            </p>
            <p className="text-ngbc-dark-text mt-4">
              Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. 
              Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die 
              vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. 
              Sie erläutert auch, wie und zu welchem Zweck das geschieht.
            </p>

            <h3 className="text-xl font-semibold text-ngbc-dark mb-3 mt-6">Hinweis zur verantwortlichen Stelle</h3>
            <p className="text-ngbc-dark-text">
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
            </p>
            <p className="text-ngbc-dark-text mt-4">
              [Firmenname]<br />
              [Straße und Hausnummer]<br />
              [PLZ und Ort]<br />
              <br />
              Telefon: [Telefonnummer]<br />
              E-Mail: [E-Mail-Adresse]
            </p>
            <p className="text-ngbc-dark-text mt-4">
              Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit 
              anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z. B. Namen, 
              E-Mail-Adressen o. Ä.) entscheidet.
            </p>

            <h3 className="text-xl font-semibold text-ngbc-dark mb-3 mt-6">Speicherdauer</h3>
            <p className="text-ngbc-dark-text">
              Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, 
              verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. 
              Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung 
              widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für 
              die Speicherung Ihrer personenbezogenen Daten haben (z. B. steuer- oder handelsrechtliche 
              Aufbewahrungsfristen); im letztgenannten Fall erfolgt die Löschung nach Fortfall dieser Gründe.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">5. Datenerfassung auf dieser Website</h2>
            <h3 className="text-xl font-semibold text-ngbc-dark mb-3">Cookies</h3>
            <p className="text-ngbc-dark-text">
              Unsere Internetseiten verwenden so genannte "Cookies". Cookies sind kleine Datenpakete und richten 
              auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung 
              (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert.
            </p>
            <p className="text-ngbc-dark-text mt-4">
              Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und 
              Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell 
              ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren.
            </p>

            <h3 className="text-xl font-semibold text-ngbc-dark mb-3 mt-6">Server-Log-Dateien</h3>
            <p className="text-ngbc-dark-text">
              Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten 
              Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:
            </p>
            <ul className="list-disc ml-6 mt-4 text-ngbc-dark-text space-y-2">
              <li>Browsertyp und Browserversion</li>
              <li>Verwendetes Betriebssystem</li>
              <li>Referrer URL</li>
              <li>Hostname des zugreifenden Rechners</li>
              <li>Uhrzeit der Serveranfrage</li>
              <li>IP-Adresse</li>
            </ul>
            <p className="text-ngbc-dark-text mt-4">
              Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.
            </p>

            <h3 className="text-xl font-semibold text-ngbc-dark mb-3 mt-6">Kontaktformular und Anmeldung</h3>
            <p className="text-ngbc-dark-text">
              Wenn Sie uns per Kontaktformular oder bei der Anmeldung zur Veranstaltung Anfragen zukommen lassen, 
              werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten 
              zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
            </p>
            <p className="text-ngbc-dark-text mt-4">
              Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre 
              Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher 
              Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten 
              Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) 
              oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">6. Ihre Rechte</h2>
            <p className="text-ngbc-dark-text">
              Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:
            </p>
            <ul className="list-disc ml-6 mt-4 text-ngbc-dark-text space-y-2">
              <li><strong>Recht auf Auskunft:</strong> Sie können Auskunft über Ihre gespeicherten personenbezogenen Daten verlangen.</li>
              <li><strong>Recht auf Berichtigung:</strong> Sie können die Berichtigung unrichtiger Daten verlangen.</li>
              <li><strong>Recht auf Löschung:</strong> Sie können die Löschung Ihrer Daten verlangen, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.</li>
              <li><strong>Recht auf Einschränkung:</strong> Sie können die Einschränkung der Verarbeitung verlangen.</li>
              <li><strong>Recht auf Datenübertragbarkeit:</strong> Sie können Ihre Daten in einem strukturierten Format erhalten.</li>
              <li><strong>Widerspruchsrecht:</strong> Sie können der Verarbeitung Ihrer Daten widersprechen.</li>
              <li><strong>Beschwerderecht:</strong> Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">7. Widerruf Ihrer Einwilligung zur Datenverarbeitung</h2>
            <p className="text-ngbc-dark-text">
              Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können 
              eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf 
              erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">8. SSL- bzw. TLS-Verschlüsselung</h2>
            <p className="text-ngbc-dark-text">
              Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine 
              SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die 
              Adresszeile des Browsers von "http://" auf "https://" wechselt und an dem Schloss-Symbol in Ihrer 
              Browserzeile.
            </p>
          </section>

          <section className="border-t pt-6">
            <p className="text-gray-600 text-sm italic">
              {L('stand')}
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};
